import { useMemo, useEffect } from "react";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import rtlPlugin from "@mui/stylis-plugin-rtl";
import { useTranslation } from "react-i18next";
import App from "./App";

import { ThemeProvider, CssBaseline } from "@mui/material";
import { getAppTheme } from "./Theme";

const Root = () => {
  const { i18n } = useTranslation();
  
  const isRTL = i18n.language === "ar";
  document.body.dir = isRTL ? "rtl" : "ltr";
  const cacheRtl = useMemo(
    () =>
      createCache({
        key: isRTL ? "muirtl" : "mui",
        stylisPlugins: isRTL ? [rtlPlugin] : [],
      }),
    [isRTL]
  );
  const theme = useMemo(
    () => getAppTheme(isRTL),
  [isRTL]);

  return (
    <CacheProvider value={cacheRtl}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App key={i18n.language}/>
      </ThemeProvider>
    </CacheProvider>
  );
};

export default Root;
